require('./fin-antenniste.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class FinAntennisteComponent {
  constructor() {
    this.controller = FinAntennisteController;
    this.template = require('./fin-antenniste.html');
  }
}

// @ngInject
class FinAntennisteController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.FINANTENNISTE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.finAntenniste ? state.demande.data.finAntenniste.asMutable({deep: true}) : this.data,
          numeroAnfr: state.demande.data.numeroAnfr
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateFinAntenniste(this.data, true));
  }

  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateFinAntenniste(this.data));
  }

}



// WEBPACK FOOTER //
// ./src/modules/antenniste/components/fin-antenniste/fin-antenniste.component.js